/*
 * @Date: 2022-08-23 09:49:17
 * @LastEditors: kinfai
 * @Description: 主页
 * @LastEditTime: 2022-09-14 10:08:10
 * @FilePath: \my-app\src\App.js
 */

import './App.less'
import ImManage from "./pages/ImManage/index.jsx";
import SetupBtn from "./pages/SetupBtn";
import {useEffect, useState} from "react";
import {ConfigProvider} from 'antd';
import {TurmsContext} from "./provide/turms-context.js";

// 由于 antd 组件的默认文案是英文，所以需要修改为中文
import zhCN from 'antd/es/locale/zh_CN';
import moment from 'moment';
import 'moment/locale/zh-cn';
// import 'antd/dist/antd.min.css'
import 'antd/dist/antd.variable.min.css';
import useTurms from "@/hooks/turms/index.js";
// import {getPluginConfig} from "@/hooks/chatPlugin/index.js";


moment.locale('zh-cn');

window.addEventListener("message", e => {
    try {
        const {type, data} = JSON.parse(e.data);
        if (type === 'companyInfo') {
            localStorage.setItem("webPluginConfig", JSON.stringify(data))
            ConfigProvider.config({
                theme: {
                    primaryColor: data.btnColor || ""
                },
            });
        }
    } catch (e) {

    }
}, false)

// setTimeout(() => {
//     const pgConfig = getPluginConfig()
//     ConfigProvider.config({
//         theme: {
//             primaryColor: pgConfig.btnColor || ""
//         },
//     });
// }, 2000)


function App() {
    const [status, setStatus] = useState(true);
    const [socket, initSocket] = useState(null)
    const {initTurms} = useTurms()

    let turmsClient;
    let isInit = true
    useEffect(() => {
        const main = async () => {
            turmsClient = await initTurms()
            initSocket(turmsClient)
        }
        isInit && main()

        return () => {
            isInit = false
        }
    }, [])

    const toggleStatus = () => {
        const value = !status;
        setStatus(value)
    }

    return (<ConfigProvider locale={zhCN}>
        <TurmsContext.Provider value={{trumsClient: socket}}>
            <div className="App">
                <SetupBtn
                    handleToggle={toggleStatus}
                    status={status}
                ></SetupBtn>
                <ImManage show={status}
                />
            </div>
        </TurmsContext.Provider>
    </ConfigProvider>);
}

export default App;
